<div class="app">

  <!-- ── Status Bar ── -->
  <div class="status-bar">
    <span class="status-time">{{ currentTime() }}</span>
    <div class="status-icons">
      <svg width="15" height="11" viewBox="0 0 16 12" fill="white">
        <rect x="0" y="7" width="3" height="5" rx="0.5" opacity="0.4"/>
        <rect x="4.5" y="5" width="3" height="7" rx="0.5" opacity="0.6"/>
        <rect x="9" y="2" width="3" height="10" rx="0.5" opacity="0.8"/>
        <rect x="13.5" y="0" width="2.5" height="12" rx="0.5"/>
      </svg>
      <svg width="15" height="11" viewBox="0 0 24 24" fill="white">
        <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/>
      </svg>
      <svg width="24" height="11" viewBox="0 0 25 12" fill="white">
        <rect x="0" y="1" width="21" height="10" rx="3" stroke="white" stroke-width="1" fill="none"/>
        <rect x="22" y="4" width="2" height="4" rx="1" fill="white" opacity="0.5"/>
        <rect x="1.5" y="2.5" width="15" height="7" rx="2" fill="white"/>
      </svg>
    </div>
  </div>

  <!-- ── Push notification ── -->
  @if (pushNotif()) {
    <div class="push-notif" (click)="onPushNotifClick()">
      <div class="pn-row">
        <div class="pn-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
          </svg>
        </div>
        <div class="pn-content">
          <div class="pn-meta">
            <span class="pn-app">Waitora</span>
            <span class="pn-time">{{ 'mobileSimulator.shell.pushNotif.now' | translate }}</span>
          </div>
          <p class="pn-title">{{ pushNotif()!.title }}</p>
          <p class="pn-body">{{ pushNotif()!.body }}</p>
        </div>
      </div>
    </div>
  }

  <!-- ── App Header ── -->
  <div class="app-header" [class.app-header--detail]="isDetailOpen() || reseauView() === 'list' || commPatientOpen() || canalOpen() || modeDegradeOpen() || renfortOpen() || avisPatientOpen() || satisfactionOpen()" >

    @if (satisfactionOpen()) {
      <button class="header-back-btn" (click)="closeSatisfaction()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.satisfaction' | translate }}</span>
      </button>
    } @else if (avisPatientOpen()) {
      <button class="header-back-btn" (click)="closeAvisPatient()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.avisPatients' | translate }}</span>
      </button>
    } @else if (renfortOpen()) {
      <button class="header-back-btn" (click)="closeRenfort()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.retour' | translate }}</span>
      </button>
    } @else if (modeDegradeOpen()) {
      <button class="header-back-btn" (click)="closeModeDegrade()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.retour' | translate }}</span>
      </button>
    } @else if (canalOpen()) {
      <button class="header-back-btn" (click)="closeCanal()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.retour' | translate }}</span>
      </button>
    } @else if (commPatientOpen()) {
      <button class="header-back-btn" (click)="closeCommPatient()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.retour' | translate }}</span>
      </button>
    } @else if (isDetailOpen()) {
      <button class="header-back-btn" (click)="closeSite()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.retour' | translate }}</span>
      </button>
    } @else if (reseauView() === 'list') {
      <button class="header-back-btn" (click)="showDashboard()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        <span class="header-back-label">{{ 'mobileSimulator.common.retour' | translate }}</span>
      </button>
    } @else {
      <button class="account-btn">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
        </svg>
      </button>
      <button class="notif-btn" (click)="toggleNotifications()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" fill="currentColor"/>
        </svg>
        @if (notificationCount() > 0) {
          <span class="notif-badge">{{ notificationCount() }}</span>
        }
      </button>
    }

  </div>

  <!-- ── Contenu ── -->
  <div class="screen-content"
    [class.screen-content--slide]="(activeTab() === 'reseau' || activeTab() === 'mon-site') && !showNotifications()"
    [class.screen-content--scrolled]="isScrolled()"
    (scroll)="onListScroll($event)">

    @if (showNotifications()) {
      <div class="notif-panel">

        <div class="notif-header">
          <div class="notif-header-left">
            <span class="notif-panel-title">{{ 'mobileSimulator.shell.notifications.title' | translate }}</span>
            @if (notifications.length > 0) {
              <span class="notif-count-badge">{{ notifications.length }}</span>
            }
          </div>
          <button class="notif-read-all" (click)="markAllRead()">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
            {{ 'mobileSimulator.shell.notifications.readAll' | translate }}
          </button>
        </div>

        @if (notifications.length === 0) {
          <div class="notif-empty">
            <div class="notif-empty-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.43.12l7.93 9.88z"/>
              </svg>
            </div>
            <p class="notif-empty-title">{{ 'mobileSimulator.shell.notifications.emptyTitle' | translate }}</p>
            <p class="notif-empty-sub">{{ 'mobileSimulator.shell.notifications.emptySub' | translate }}</p>
          </div>
        } @else {
          <div class="notif-date-sep"><span>{{ 'mobileSimulator.common.aujourdHui' | translate }}</span></div>
          <div class="notif-list">
            @for (n of notifications; track n.id) {
              <div class="notif-card" [attr.data-severity]="n.severity">
                <div class="nc-icon" [attr.data-severity]="n.severity">
                  @if (n.severity === 'critique') {
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                  }
                  @if (n.severity === 'warning') {
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                    </svg>
                  }
                  @if (n.severity === 'info') {
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                    </svg>
                  }
                </div>
                <div class="nc-content">
                  <div class="nc-top">
                    <span class="nc-chip" [attr.data-severity]="n.severity">{{ severityLabel(n.severity) }}</span>
                    <span class="nc-time">{{ n.time }}</span>
                  </div>
                  <p class="nc-title">{{ n.title }}</p>
                  <p class="nc-body">{{ n.body }}</p>
                </div>
              </div>
            }
          </div>
        }

      </div>

    } @else {
      @switch (activeTab()) {
        @case ('reseau') {
          <div class="slide-wrap">
            <div class="slide-list" [class.slide-list--pushed]="selectedSite() && !detailExiting()" (scroll)="onListScroll($event)">
              @if (reseauView() === 'list') {
                <app-reseau-screen (siteSelected)="openSite($event)" />
              } @else {
                <app-dashboard-screen [scrollY]="scrollY()" (openList)="showList()" (openActus)="setTab('actus')" (siteSelected)="openSite($event)" (openAvisPatient)="openAvisPatientScreen()" (openSatisfaction)="openSatisfactionScreen()" />
              }
            </div>
            @if (selectedSite()) {
              <div class="slide-detail" [class.slide-detail--out]="detailExiting()" (scroll)="onListScroll($event)">
                <app-site-detail-screen [site]="selectedSite()!" (openCommPatient)="openCommPatient()" (openCanal)="openCanal()" (openModeDegrade)="openModeDegrade()" (openRenfort)="openRenfort(selectedSite()!.nom, selectedSite()!.statut)" />
              </div>
            }
            @if (commPatientOpen() && selectedSite()) {
              <div class="slide-detail" [class.slide-detail--out]="commPatientExiting()" (scroll)="onListScroll($event)">
                <app-comm-patient-screen [site]="selectedSite()!" />
              </div>
            }
            @if (canalOpen() && selectedSite()) {
              <div class="slide-detail" [class.slide-detail--out]="canalExiting()" (scroll)="onListScroll($event)">
                <app-canal-screen
                  [site]="selectedSite()!"
                  [filterRoles]="canalFilterRoles()"
                  [filterSites]="canalFilterSites()"
                  (openFilter)="openCanalFilter()"
                  (canalCreated)="onCanalCreated($event)" />
              </div>
            }
            @if (modeDegradeOpen() && selectedSite()) {
              <div class="slide-detail" [class.slide-detail--out]="modeDegradeExiting()">
                <app-mode-degrade-screen [site]="selectedSite()!" (activated)="onModeDegradeActivated()" />
              </div>
            }
            @if (renfortOpen() && selectedSite()) {
              <div class="slide-detail" [class.slide-detail--out]="renfortExiting()" (scroll)="onListScroll($event)">
                <app-renfort-screen [siteName]="renfortSiteName()" [siteStatut]="renfortSiteStatut()" [tensionMinutes]="renfortTensionMinutes()" (sent)="onRenfortSent($event)" />
              </div>
            }
            @if (avisPatientOpen()) {
              <div class="slide-detail" [class.slide-detail--out]="avisPatientExiting()" (scroll)="onListScroll($event)">
                <app-avis-patient-screen />
              </div>
            }
            @if (satisfactionOpen()) {
              <div class="slide-detail" [class.slide-detail--out]="satisfactionExiting()" (scroll)="onListScroll($event)">
                <app-satisfaction-screen />
              </div>
            }
          </div>
        }
        @case ('mon-site') {
          <div class="slide-wrap">
            <div class="slide-list"
              [class.slide-list--pushed]="(renfortOpen() && !renfortExiting()) || (modeDegradeOpen() && !modeDegradeExiting()) || (commPatientOpen() && !commPatientExiting()) || (canalOpen() && !canalExiting())"
              (scroll)="onListScroll($event)">
              <app-mon-site-screen
                (openRenfort)="openRenfort('Nantes Centre', 'critique', 45)"
                (openModeDegrade)="openModeDegrade()"
                (openCommPatient)="openCommPatient()"
                (openCanal)="openCanal()"
                (openCanalWith)="openCanalWithCollegue($event)"
                (openNotifAide)="openNotifAide()" />
            </div>
            @if (renfortOpen()) {
              <div class="slide-detail" [class.slide-detail--out]="renfortExiting()" (scroll)="onListScroll($event)">
                <app-renfort-screen [siteName]="renfortSiteName()" [siteStatut]="renfortSiteStatut()" [tensionMinutes]="renfortTensionMinutes()" (sent)="onRenfortSent($event)" />
              </div>
            }
            @if (modeDegradeOpen()) {
              <div class="slide-detail" [class.slide-detail--out]="modeDegradeExiting()">
                <app-mode-degrade-screen [site]="monSite" (activated)="onModeDegradeActivated()" />
              </div>
            }
            @if (commPatientOpen()) {
              <div class="slide-detail" [class.slide-detail--out]="commPatientExiting()" (scroll)="onListScroll($event)">
                <app-comm-patient-screen [site]="monSite" />
              </div>
            }
            @if (canalOpen()) {
              <div class="slide-detail" [class.slide-detail--out]="canalExiting()" (scroll)="onListScroll($event)">
                <app-canal-screen
                  [site]="monSite"
                  [filterRoles]="canalFilterRoles()"
                  [filterSites]="canalFilterSites()"
                  (openFilter)="openCanalFilter()"
                  (canalCreated)="onCanalCreated($event)" />
              </div>
            }
          </div>
        }
        @case ('message')  { <app-message-screen [openCanal]="pendingCanal()" [openDirectThread]="directMessageNom()" /> }
        @case ('actus')    { <app-actus-screen [filterSites]="actusFilterSites()" (openFilter)="openActusFilter()" /> }
      }
    }

  </div>

  <!-- ── Filter sheet canal ── -->
  @if (canalFilterOpen()) {
    <div class="filter-overlay" (click)="closeCanalFilter()"></div>
    <div class="filter-sheet"
      [class.filter-sheet--dragging]="sheetIsDragging()"
      [style.transform]="'translateY(' + sheetDragDelta() + 'px)'">
      <div class="filter-handle"
        (pointerdown)="onSheetPointerDown($event)"
        (pointermove)="onSheetPointerMove($event)"
        (pointerup)="onSheetPointerUp()"
        (pointercancel)="onSheetPointerUp()"></div>
      <div class="filter-header">
        <span class="filter-title">{{ 'mobileSimulator.shell.filter.title' | translate }}</span>
        @if (canalHasFilter()) {
          <button class="filter-reset" (click)="resetCanalFilters()">{{ 'mobileSimulator.common.reinitialiser' | translate }}</button>
        }
      </div>

      <p class="filter-section">{{ 'mobileSimulator.common.sites' | translate }}</p>
      <div class="filter-check-list">
        @for (s of canalAllSites; track s) {
          <button class="filter-check-row" [class.filter-check-row--active]="canalFilterSites().includes(s)" (click)="toggleCanalSite(s)">
            <span>{{ s }}</span>
            <span class="filter-check-box" [class.filter-check-box--on]="canalFilterSites().includes(s)">
              @if (canalFilterSites().includes(s)) {
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              }
            </span>
          </button>
        }
      </div>

      <p class="filter-section">{{ 'mobileSimulator.common.metiers' | translate }}</p>
      <div class="filter-check-list">
        @for (r of canalAllRoles; track r) {
          <button class="filter-check-row" [class.filter-check-row--active]="canalFilterRoles().includes(r)" (click)="toggleCanalRole(r)">
            <span>{{ r }}</span>
            <span class="filter-check-box" [class.filter-check-box--on]="canalFilterRoles().includes(r)">
              @if (canalFilterRoles().includes(r)) {
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              }
            </span>
          </button>
        }
      </div>

      <button class="filter-apply" (click)="closeCanalFilter()">{{ 'mobileSimulator.common.appliquer' | translate }}</button>
    </div>
  }

  <!-- ── Bottom sheet : Notifier disponibilité ── -->
  @if (notifAideOpen()) {
    <div class="filter-overlay" (click)="closeNotifAide()"></div>
    <div class="filter-sheet"
      [class.filter-sheet--dragging]="sheetIsDragging()"
      [style.transform]="'translateY(' + sheetDragDelta() + 'px)'">
      <div class="filter-handle"
        (pointerdown)="onSheetPointerDown($event)"
        (pointermove)="onSheetPointerMove($event)"
        (pointerup)="onSheetPointerUp()"
        (pointercancel)="onSheetPointerUp()"></div>

      @if (notifAideSent()) {
        <div class="notif-aide-confirm">
          <div class="nac-icon">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </div>
          <p class="nac-title">{{ 'mobileSimulator.shell.notifAide.sentTitle' | translate }}</p>
          <p class="nac-sub">{{ (notifAideSites().length > 1 ? 'mobileSimulator.shell.notifAide.confirmPlural' : 'mobileSimulator.shell.notifAide.confirmSingular') | translate: { count: notifAideSites().length } }}</p>
        </div>
      } @else {
        <div class="filter-header">
          <div class="notif-aide-header-left">
            <div class="notif-aide-bell">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
              </svg>
            </div>
            <span class="filter-title">{{ 'mobileSimulator.shell.notifAide.title' | translate }}</span>
          </div>
        </div>
        <p class="notif-aide-sub">{{ 'mobileSimulator.shell.notifAide.subtitle' | translate }}</p>
        <div class="filter-check-list">
          @for (s of notifAideAllSites; track s) {
            <button class="filter-check-row" [class.filter-check-row--active]="notifAideSites().includes(s)" (click)="toggleNotifAideSite(s)">
              <span>{{ s }}</span>
              <span class="filter-check-box" [class.filter-check-box--on]="notifAideSites().includes(s)">
                @if (notifAideSites().includes(s)) {
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                }
              </span>
            </button>
          }
        </div>
        <button class="filter-apply" [disabled]="notifAideSites().length === 0" (click)="sendNotifAide()">
          {{ 'mobileSimulator.shell.notifAide.sendButton' | translate }}
        </button>
      }
    </div>
  }

  <!-- ── Filter sheet actus ── -->
  @if (actusFilterOpen()) {
    <div class="filter-overlay" (click)="closeActusFilter()"></div>
    <div class="filter-sheet"
      [class.filter-sheet--dragging]="sheetIsDragging()"
      [style.transform]="'translateY(' + sheetDragDelta() + 'px)'">
      <div class="filter-handle"
        (pointerdown)="onSheetPointerDown($event)"
        (pointermove)="onSheetPointerMove($event)"
        (pointerup)="onSheetPointerUp()"
        (pointercancel)="onSheetPointerUp()"></div>
      <div class="filter-header">
        <span class="filter-title">{{ 'mobileSimulator.shell.actusFilter.title' | translate }}</span>
        @if (actusFilterSites().length > 0) {
          <button class="filter-reset" (click)="resetActusFilters()">{{ 'mobileSimulator.common.reinitialiser' | translate }}</button>
        }
      </div>
      <div class="filter-check-list">
        @for (s of actusAllSites; track s) {
          <button class="filter-check-row" [class.filter-check-row--active]="actusFilterSites().includes(s)" (click)="toggleActusSite(s)">
            <span>{{ s }}</span>
            <span class="filter-check-box" [class.filter-check-box--on]="actusFilterSites().includes(s)">
              @if (actusFilterSites().includes(s)) {
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              }
            </span>
          </button>
        }
      </div>
      <button class="filter-apply" (click)="closeActusFilter()">{{ 'mobileSimulator.common.appliquer' | translate }}</button>
    </div>
  }

  <!-- ── Bottom Tab Bar ── -->
  <nav class="bottom-bar">
    <button class="tab-item" [class.active]="activeTab() === 'reseau' && !showNotifications()" (click)="setTab('reseau')">
      <div class="tab-inner">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
        </svg>
        <span>{{ 'mobileSimulator.shell.nav.supervision' | translate }}</span>
      </div>
    </button>
    <button class="tab-item" [class.active]="activeTab() === 'mon-site' && !showNotifications()" (click)="setTab('mon-site')">
      <div class="tab-inner">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
        <span>{{ 'mobileSimulator.common.monSite' | translate }}</span>
      </div>
    </button>
    <button class="tab-item" [class.active]="activeTab() === 'message' && !showNotifications()" (click)="setTab('message')">
      <div class="tab-inner">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
        </svg>
        <span>{{ 'mobileSimulator.shell.nav.message' | translate }}</span>
      </div>
    </button>
    <button class="tab-item" [class.active]="activeTab() === 'actus' && !showNotifications()" (click)="setTab('actus')">
      <div class="tab-inner">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
        </svg>
        <span>{{ 'mobileSimulator.shell.nav.actus' | translate }}</span>
      </div>
    </button>
  </nav>

</div>